import {
	periodTypesEnum,
	rosterStatusesEnum,
	unitStateEnum,
	dateRangeGroupEnum,
	dateRangeNameEnum,
	localeCodeEnum
} from './enums';

export const orgUnitLevels = [
	{ id: 1, name: 'Trust', label: 'enum_LevelTrust' },
	{ id: 2, name: 'Hospital', label: 'enum_LevelHospital' },
	{ id: 3, name: 'Division', label: 'enum_LevelDivision' },
	{ id: 4, name: 'Department', label: 'enum_LevelDepartment' },
	{ id: 5, name: 'Ward/Unit', label: 'enum_LevelWardUnit' }
];

export const periodTypes = [
	{
		id: 1,
		name: periodTypesEnum.Daily,
		label: 'enum_MeasurementPeriodDaily'
	},
	{
		id: 2,
		name: periodTypesEnum.Weekly,
		label: 'enum_MeasurementPeriodWeekly'
	},
	{
		id: 3,
		name: periodTypesEnum.FourWeeks,
		label: 'enum_MeasurementPeriodFourWeeks'
	},
	{
		id: 4,
		name: periodTypesEnum.Monthly,
		label: 'enum_MeasurementPeriodMonthly'
	},
	{
		id: 5,
		name: periodTypesEnum.Quarterly,
		label: 'enum_MeasurementPeriodQuarterly'
	},
	{
		id: 6,
		name: periodTypesEnum.WholePeriod,
		label: 'enum_MeasurementPeriodWholePeriod'
	}
];

export const rosterStatuses = [
	{
		id: 1,
		name: rosterStatusesEnum.Approved,
		label: 'enum_RosterStatusApproved'
	},
	{
		id: 2,
		name: rosterStatusesEnum.Pending,
		label: 'enum_RosterStatusPending'
	},
	{
		id: 3,
		name: rosterStatusesEnum.Any,
		label: 'enum_RosterStatusAny'
	}
];

export const unitStates = [
	{
		id: 1,
		value: [unitStateEnum.VisibleComparable, unitStateEnum.VisibleNonComparable, unitStateEnum.Hidden],
		label: 'label_All'
	},
	{
		id: 2,
		value: [unitStateEnum.VisibleComparable],
		label: 'label_VisibleComparable'
	},
	{
		id: 3,
		value: [unitStateEnum.VisibleNonComparable],
		label: 'label_VisibleNonComparable'
	},
	{
		id: 4,
		value: [unitStateEnum.VisibleComparable, unitStateEnum.VisibleNonComparable],
		label: 'label_VisibleComparableAndNonComparable'
	},
	{
		id: 5,
		value: [unitStateEnum.Hidden],
		label: 'label_Hidden'
	}
];

export const locales = [
	{
		countryCode: 'GB',
		languageCode: localeCodeEnum.EnglishUnitedKingdom,
		localeKey: 'enGB',
		label: 'English (UK)'
	},
	{
		countryCode: 'US',
		languageCode: localeCodeEnum.EnglishUnitedStates,
		localeKey: 'enUS',
		label: 'English (US)'
	},
	{
		countryCode: 'AU',
		languageCode: localeCodeEnum.EnglishAustralia,
		localeKey: 'enAU',
		label: 'English (AU)'
	},
	{
		countryCode: 'DK',
		languageCode: localeCodeEnum.Danish,
		localeKey: 'da',
		label: 'Dansk (DK)'
	},
	{
		countryCode: 'DE',
		languageCode: localeCodeEnum.German,
		localeKey: 'de',
		label: 'Deutsch (DE)'
	}
];

export const relativeDateRanges = [
	{ name: dateRangeNameEnum.Yesterday, labelKey: 'date_Yesterday', group: dateRangeGroupEnum.Day },
	{ name: dateRangeNameEnum.Today, labelKey: 'date_Today', group: dateRangeGroupEnum.Day },
	{ name: dateRangeNameEnum.Tomorrow, labelKey: 'date_Tomorrow', group: dateRangeGroupEnum.Day },
	{ name: dateRangeNameEnum.LastWeek, labelKey: 'date_LastWeek', group: dateRangeGroupEnum.Week },
	{ name: dateRangeNameEnum.CurrentWeek, labelKey: 'date_CurrentWeek', group: dateRangeGroupEnum.Week },
	{ name: dateRangeNameEnum.NextWeek, labelKey: 'date_NextWeek', group: dateRangeGroupEnum.Week },
	{ name: dateRangeNameEnum.LastMonth, labelKey: 'date_LastMonth', group: dateRangeGroupEnum.Month },
	{ name: dateRangeNameEnum.CurrentMonth, labelKey: 'date_CurrentMonth', group: dateRangeGroupEnum.Month },
	{ name: dateRangeNameEnum.NextMonth, labelKey: 'date_NextMonth', group: dateRangeGroupEnum.Month },
	{ name: dateRangeNameEnum.LastQuarter, labelKey: 'date_LastQuarter', group: dateRangeGroupEnum.Quarter },
	{ name: dateRangeNameEnum.CurrentQuarter, labelKey: 'date_CurrentQuarter', group: dateRangeGroupEnum.Quarter },
	{ name: dateRangeNameEnum.NextQuarter, labelKey: 'date_NextQuarter', group: dateRangeGroupEnum.Quarter },
	{ name: dateRangeNameEnum.LastYear, labelKey: 'date_LastYear', group: dateRangeGroupEnum.Year },
	{ name: dateRangeNameEnum.CurrentYear, labelKey: 'date_CurrentYear', group: dateRangeGroupEnum.Year },
	{ name: dateRangeNameEnum.NextYear, labelKey: 'date_NextYear', group: dateRangeGroupEnum.Year },
	{
		name: dateRangeNameEnum.LastRosterCycle,
		labelKey: 'date_LastRosterCycle',
		group: dateRangeGroupEnum.RosterCycle
	},
	{
		name: dateRangeNameEnum.CurrentRosterCycle,
		labelKey: 'date_CurrentRosterCycle',
		group: dateRangeGroupEnum.RosterCycle
	},
	{ name: dateRangeNameEnum.NextRosterCycle, labelKey: 'date_NextRosterCycle', group: dateRangeGroupEnum.RosterCycle }
];

export const deliveryOptionsList = [
	{ frequency: 'Daily', label: 'label_SchedulerDaily', value: 0 },
	{ frequency: 'Weekly', label: 'label_SchedulerWeekly', value: 1 },
	{ frequency: 'Monthly', label: 'label_SchedulerMonthly', value: 2 },
	{ frequency: 'RosterCycle', label: 'date_RosterCycle', value: 3 }
];

export const legacyDeliveryOptionsList = [
	{ frequency: 'Today', label: 'label_SchedulerToday', value: 0 },
	{ frequency: 'TodayTomorrow', label: 'label_SchedulerTodayTomorrow', value: 1 },
	{ frequency: 'CurrentWeek', label: 'label_SchedulerCurrentWeek', value: 2 },
	{ frequency: 'PreviousWeek', label: 'label_SchedulerPreviousWeek', value: 3 },
	{ frequency: 'NextWeek', label: 'label_SchedulerNextWeek', value: 4 },
	{ frequency: 'CurrentRosterCycle', label: 'label_SchedulerCurrentRosterCycle', value: 5 },
	{ frequency: 'PreviousRosterCycle', label: 'label_SchedulerPreviousRosterCycle', value: 6 },
	{ frequency: 'NextRosterCycle', label: 'label_SchedulerNextRosterCycle', value: 7 }
];

export const deliveryTypeList = [
	{ format: 'XLSX', value: 0 },
	{ format: 'CSV', value: 1 },
	{ format: 'HTML', value: 2 }
];

export const monthlyOccurrenceOptions = [
	{ label: 'label_DayOfWeekFirst', value: 1 },
	{ label: 'label_DayOfWeekSecond', value: 2 },
	{ label: 'label_DayOfWeekThird', value: 3 },
	{ label: 'label_DayOfWeekFourth', value: 4 },
	{ label: 'label_DayOfWeekLast', value: 0 }
];

export const cycleRecurrenceOptions = [
	{ label: 'label_RosterCycleStart', value: 0 },
	{ label: 'label_RosterCycleOneWeekBefore', value: 1 },
	{ label: 'label_RosterCycleTwoWeeksBefore', value: 2 },
	{ label: 'label_RosterCycleThreeWeeksBefore', value: 3 },
	{ label: 'label_RosterCycleFourWeeksBefore', value: 4 }
];

export const emptyValueRepresentation = '/';

export const maxDateTime = '9999-12-31T00:00:00Z';

export const defaultDateFormat = 'DD MMMM YYYY';

export const leadingYearDateFormat = 'YYYY-MM-DD';
